import { createFileRoute } from "@tanstack/react-router";
import { CopilotAuthProvider } from "src/components/CopilotAuthProvider";
import { CopilotLayout } from "src/components/CopilotLayout";

function CopilotRoute() {
    const hash = window.location.hash;
    const queryIndex = hash.indexOf("?");
    const search = queryIndex >= 0 ? hash.slice(queryIndex + 1) : window.location.search;
    const urlParams = new URLSearchParams(search);
    const authMode = urlParams.get("auth") || "sso";
    const loginHint = urlParams.get("loginHint") || undefined;

    return (
        <CopilotAuthProvider
            authMode={authMode as "popup" | "sso" | "inherit"}
            loginHint={loginHint}
        >
            <CopilotLayout />
        </CopilotAuthProvider>
    );
}

export const Route = createFileRoute("/copilot")({
    component: CopilotRoute,
});
